import { Stack, styled } from '@mui/material';

const StyledSessionSideList = styled(Stack)(() => ({
  maxHeight: '421px',
  overflowY: 'auto'
}));

export default StyledSessionSideList;
